import { useEffect, useLayoutEffect, useState } from 'react';

import Loader from '../loader/loader';
import './select.scss';

interface ISelectProps {
  name: string;
  label: string;
  options: any[];
  register: any;
  setValue: any;
  errors?: any;
  validationRules?: any;
  required?: boolean;
  square?: boolean;
  error?: any;
  onChange?: any;
  loader?: boolean;
  disabled?: boolean;
  defaultValue?: any;
  id?: string;
  onDisplayEvent?: any;
  onSelectEvent?: any;
  forceChangeValue?: any;
  role?: string;
  isDefaultValue?: boolean;
  getValues?: any;
}

const Select = ({
  name,
  options,
  label,
  register,
  validationRules,
  error,
  id,
  onChange,
  setValue,
  defaultValue,
  onDisplayEvent,
  onSelectEvent,
  forceChangeValue,
  required,
  square,
  loader,
  role,
  disabled = false,
  isDefaultValue = false,
}: ISelectProps) => {
  const [currentOption, setCurrentOption] = useState<any>();
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (!options.length) return;
    {
      options[0] && setValue(name, options[0].value);
      setCurrentOption(options[0].name);
    }
  }, []);

  useEffect(() => {
    if (isDefaultValue) {
      setCurrentOption(defaultValue.name);
    }
    if (!defaultValue) {
      setValue(name, options[0].value);
      setCurrentOption(options[0].name);
    } else if ((defaultValue && currentOption === defaultValue.name) || !currentOption) {
      setValue(name, defaultValue.value);
      setCurrentOption(defaultValue.name);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (forceChangeValue) {
      selectForcedOption(forceChangeValue.name, forceChangeValue.value);
    }
  }, [forceChangeValue]);

  useLayoutEffect(() => {
    if (name === 'requestType') {
      setCurrentOption('Selecciona');
      setValue('requestType', '');
    }
  }, [options]);

  const selectOption = (optionName, value) => {
    const select = document.getElementById(`${id}select`);
    const option = document.getElementById(`${id}options`);
    const currentOption = document.getElementById(`${id}currentOption`);
    if (select && option && currentOption) {
      select.classList.toggle('__active');
      select.classList.remove('__error');
      option.classList.toggle('__active');
      currentOption.classList.toggle('__active');
    }
    setValue(name, value);
    setCurrentOption(optionName);
    onChange(optionName, value);

    if (label) {
      const labelName = document.getElementById(name + label);
      labelName && labelName.classList.remove('__visible');
    }

    setOpened(false);
  };

  const selectForcedOption = (optionName, value) => {
    setValue(name, value);
    setCurrentOption(optionName);
    onChange(optionName, value);

    setOpened(false);
  };

  const displayOption = () => {
    const select = document.getElementById(`${id}select`);
    const options = document.getElementById(`${id}options`);
    const currentlyOption = document.getElementById(`${id}currentOption`);
    if (label) {
      const labelName = document.getElementById(name + label);
      labelName && labelName.classList.toggle('__visible');
    }
    if (select && options && currentlyOption) {
      select.classList.toggle('__active');
      options.classList.toggle('__active');
      currentlyOption.classList.toggle('__active');
    }
  };

  return (
    <div
      className={`f-a-selectBox ${square ? ' __square' : ''}`}
      role={role}
      data-testid="selectBox"
    >
      {label && (
        <label
          id={name + label}
          htmlFor={name}
          className={`f-a-selectBox__label${required ? ' __required' : ''}`}
        >
          {label}
        </label>
      )}
      {opened && (
        <div
          className="f-a-selectBox__background"
          onClick={() => {
            if (!disabled) {
              displayOption();
              setOpened(false);
            }
          }}
        />
      )}
      <div
        data-testid="select"
        tabIndex={0}
        className={`f-a-selectBox__select ${error ? '__error' : ''}`}
        id={`${id}select`}
        onClick={() => {
          if (!disabled) {
            onDisplayEvent && onDisplayEvent();
            setOpened(!opened);
            displayOption();
          }
        }}
      >
        <div className="f-a-selectBox__select-inner">
          <div className="f-a-selectBox__select-content">
            {loader && (
              <div className="f-a-selectBox__select-content__loader">
                <Loader size="__small" />
              </div>
            )}
            <p
              data-testid="currentOption"
              id={`${id}currentOption`}
              className={defaultValue && currentOption !== defaultValue.name ? '__green' : ''}
            >
              {currentOption}
            </p>
          </div>
          {square ? (
            opened ? (
              <span className="icon-caret-up f-a-selectBox__icon" />
            ) : (
              <span className="icon-caret-down f-a-selectBox__icon" />
            )
          ) : opened ? (
            <span className="icon-chevron-up f-a-selectBox__icon" />
          ) : (
            <span className="icon-chevron-down1 f-a-selectBox__icon" />
          )}
        </div>
      </div>

      <ul className="f-a-selectBox__option-container" id={`${id}options`} data-testid="options">
        {options &&
          options.map((info, index) => {
            return (
              <li
                className="f-a-selectBox__option"
                key={index}
                onClick={() => {
                  onSelectEvent && onSelectEvent();
                  selectOption(info.name, info.value);
                }}
              >
                <p>{info.name}</p>
              </li>
            );
          })}
      </ul>
      <input type="hidden" name={name} id={name} {...register(name, validationRules)} />
      {error && <span className="f-a-selectBox__error">{error.message}</span>}
    </div>
  );
};

// Especifica los valores por defecto de props:
Select.defaultProps = {
  id: 'f-a-',
  onChange: () => {},
};

export default Select;
